import { FC } from "react";
import AppRoutes from "@routes/index";
import { Toaster } from "@/utils/toast";

const App: FC = () => {
  return (
    <>
      <Toaster />
      <AppRoutes />
    </>
  );
};

export default App;
